import React from 'react';
import useResponsive from '../hooks/useResponsive';

const ResponsiveDetailPage = ({ 
  children, 
  title, 
  onBack, 
  actions = [],
  className = '',
  hideHeader = false
}) => {
  const { isMobile, isTablet } = useResponsive();

  return (
    <div className={`responsive-detail-page ${className}`}>
      {/* Header Section - hidden when hideHeader is true (e.g. Consultant Activity view) */}
      {!hideHeader && (
      <div className="user_detail_heading">
        <div className="detail-header-left">
          <button 
            className="back-button"
            onClick={onBack}
            aria-label="Go back"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
            </svg>
          </button>
          <h4 className="Title">{title}</h4>
        </div>
        
        {actions.length > 0 && (
          <div className={`block_user_button ${isMobile ? 'mobile-actions' : ''}`}>
            {isMobile ? (
              <div className="mobile-actions-grid">
                {actions.map((action, index) => (
                  <button
                    key={index}
                    onClick={action.onClick}
                    className={`${action.className || 'btn_size'} mobile-action-btn`}
                    disabled={action.disabled}
                  >
                    {action.label}
                  </button>
                ))}
              </div>
            ) : (
              actions.map((action, index) => (
                <React.Fragment key={index}>
                  {action.type === 'dropdown' ? (
                    <div className="dropdown">
                      <button
                        className="btn btn-secondary dropdown-toggle"
                        type="button"
                        onClick={action.onToggle}
                        aria-expanded={action.isOpen ? "true" : "false"}
                      >
                        {action.label}
                      </button>
                      {action.isOpen && (
                        <ul className="dropdown-menu show">
                          {action.items.map((item, itemIndex) => (
                            <li key={itemIndex}>
                              <a
                                className="dropdown-item"
                                href={item.href || "#"}
                                onClick={item.onClick}
                              >
                                {item.label}
                              </a>
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  ) : (
                    <button
                      onClick={action.onClick}
                      className={action.className || 'btn_size'}
                      disabled={action.disabled}
                    >
                      {action.label}
                    </button>
                  )}
                </React.Fragment>
              ))
            )}
          </div>
        )}
      </div>
      )}

      {/* Content Section */}
      <div className="detail-content">
        {children}
      </div>
    </div>
  );
};

export default ResponsiveDetailPage;

